/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';
import type { EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner } from './EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner';
import {
    EmployeeLeaveBalancesSummaryLeaveTypeBalancesInnerFromJSON,
    EmployeeLeaveBalancesSummaryLeaveTypeBalancesInnerFromJSONTyped,
    EmployeeLeaveBalancesSummaryLeaveTypeBalancesInnerToJSON,
    EmployeeLeaveBalancesSummaryLeaveTypeBalancesInnerToJSONTyped,
} from './EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner';

/**
 * 
 * @export
 * @interface EmployeeLeaveBalancesSummary
 */
export interface EmployeeLeaveBalancesSummary {
    /**
     * 
     * @type {number}
     * @memberof EmployeeLeaveBalancesSummary
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeLeaveBalancesSummary
     */
    employeeId: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeLeaveBalancesSummary
     */
    leavePolicyId: number;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof EmployeeLeaveBalancesSummary
     */
    startDate: ShiftiePlainDate;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof EmployeeLeaveBalancesSummary
     */
    endDate: ShiftiePlainDate;
    /**
     * 
     * @type {Array<EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner>}
     * @memberof EmployeeLeaveBalancesSummary
     */
    leaveTypeBalances: Array<EmployeeLeaveBalancesSummaryLeaveTypeBalancesInner> | null;
}

/**
 * Check if a given object implements the EmployeeLeaveBalancesSummary interface.
 */
export function instanceOfEmployeeLeaveBalancesSummary(value: object): value is EmployeeLeaveBalancesSummary {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('leavePolicyId' in value) || value['leavePolicyId'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('leaveTypeBalances' in value) || value['leaveTypeBalances'] === undefined) return false;
    return true;
}

export function EmployeeLeaveBalancesSummaryFromJSON(json: any): EmployeeLeaveBalancesSummary {
    return EmployeeLeaveBalancesSummaryFromJSONTyped(json, false);
}

export function EmployeeLeaveBalancesSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeLeaveBalancesSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'employeeId': json['employeeId'],
        'leavePolicyId': json['leavePolicyId'],
        'startDate': ShiftiePlainDateFromJSON(json['startDate']),
        'endDate': ShiftiePlainDateFromJSON(json['endDate']),
        'leaveTypeBalances': (json['leaveTypeBalances'] == null ? null : (json['leaveTypeBalances'] as Array<any>).map(EmployeeLeaveBalancesSummaryLeaveTypeBalancesInnerFromJSON)),
    };
}

  export function EmployeeLeaveBalancesSummaryToJSON(json: any): EmployeeLeaveBalancesSummary {
      return EmployeeLeaveBalancesSummaryToJSONTyped(json, false);
  }

  export function EmployeeLeaveBalancesSummaryToJSONTyped(value?: EmployeeLeaveBalancesSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'employeeId': value['employeeId'],
        'leavePolicyId': value['leavePolicyId'],
        'startDate': ShiftiePlainDateToJSON(value['startDate']),
        'endDate': ShiftiePlainDateToJSON(value['endDate']),
        'leaveTypeBalances': (value['leaveTypeBalances'] == null ? null : (value['leaveTypeBalances'] as Array<any>).map(EmployeeLeaveBalancesSummaryLeaveTypeBalancesInnerToJSON)),
    };
}

